// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body:has(.errorHomePage)  {
    margin: 0;
    padding: 0;
    font-family: Arial, sans-serif;
    background-color: #273d71;
    color: #fff;
  }

  .container.errorHomePage {
    max-width: 600px;
    margin: 100px auto;
    background-color: #fff;
    padding: 30px;
    border-radius: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }

  .errorHomePage h1 {
    text-align: center;
    color: #273d71;
  }

  .errorHomePage p {
    text-align: center;
    color: #333;
  }

  .errorHomePage .contact {
    text-align: center;
    margin-top: 20px;
  }

  .errorHomePage .contact a {
    color: #007bff;
    text-decoration: none;
  }

  .errorHomePage .logo {
    text-align: center;
    margin-bottom: 20px;
  }

  .errorHomePage .logo img {
    width: 150px;
  }

  .errorHomePage #redirectMessage {
    text-align: center;
    margin-top: 20px;
  }`, "",{"version":3,"sources":["webpack://./src/Components/Error/error.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,8BAA8B;IAC9B,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;EAC1C;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB","sourcesContent":["body:has(.errorHomePage)  {\n    margin: 0;\n    padding: 0;\n    font-family: Arial, sans-serif;\n    background-color: #273d71;\n    color: #fff;\n  }\n\n  .container.errorHomePage {\n    max-width: 600px;\n    margin: 100px auto;\n    background-color: #fff;\n    padding: 30px;\n    border-radius: 10px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  }\n\n  .errorHomePage h1 {\n    text-align: center;\n    color: #273d71;\n  }\n\n  .errorHomePage p {\n    text-align: center;\n    color: #333;\n  }\n\n  .errorHomePage .contact {\n    text-align: center;\n    margin-top: 20px;\n  }\n\n  .errorHomePage .contact a {\n    color: #007bff;\n    text-decoration: none;\n  }\n\n  .errorHomePage .logo {\n    text-align: center;\n    margin-bottom: 20px;\n  }\n\n  .errorHomePage .logo img {\n    width: 150px;\n  }\n\n  .errorHomePage #redirectMessage {\n    text-align: center;\n    margin-top: 20px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
